import { render, staticRenderFns } from "./ReLeadLentaNest.vue?vue&type=template&id=64536223&scoped=true"
import script from "./ReLeadLentaNest.vue?vue&type=script&lang=js"
export * from "./ReLeadLentaNest.vue?vue&type=script&lang=js"
import style0 from "./ReLeadLentaNest.vue?vue&type=style&index=0&id=64536223&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64536223",
  null
  
)

export default component.exports